import { inject, provideAppInitializer } from '@angular/core';

import { NotificationEntitiesService } from '@notifications/services/notification-entities.service';
import { ALL_ITEMS_EXCEL_EXPORT_NOTIFICATIONS } from '@all-items/models/all-items-excel-export-notifications';

export function registerAllItemsNotifications(): Promise<void> {
  const notificationEntitiesService = inject(NotificationEntitiesService);

  notificationEntitiesService.registerEntities(
    ALL_ITEMS_EXCEL_EXPORT_NOTIFICATIONS
  );

  return Promise.resolve();
}

export const ALL_ITEMS_INITIALIZER = provideAppInitializer(() =>
  registerAllItemsNotifications()
);
